// mds-dojo — dijit/_ConfirmDialogMixin — FAITHFUL port of references/dijit/_ConfirmDialogMixin.js.
// Mixin for Dialog/TooltipDialog with OK/Cancel buttons. AMD → ESM + declare from the
// faithful runtime. dojo/i18n!./nls/common → OK/Cancel labels inlined;
// dojo/text!./templates/actionBar.html → import ?raw; dijit/form/Button imported for
// its side effect (the actionBar template instantiates data-dojo-type='dijit/form/Button').
import declare from '../dojo/_base/declare-runtime';
import _WidgetsInTemplateMixin from './_WidgetsInTemplateMixin';
import actionBarMarkup from './templates/actionBar.html?raw';
import './form/Button';		// used by template

export default declare('dijit._ConfirmDialogMixin', _WidgetsInTemplateMixin, {
  // summary:
  //		Mixin for Dialog/TooltipDialog with OK/Cancel buttons.

  // HTML snippet for action bar, overrides _DialogMixin.actionBarTemplate
  actionBarTemplate: actionBarMarkup,

  // buttonOk: String
  //		Label of OK button
  buttonOk: 'OK',
  _setButtonOkAttr: { node: 'okButton', attribute: 'label' },

  // buttonCancel: String
  //		Label of cancel button
  buttonCancel: 'Cancel',
  _setButtonCancelAttr: { node: 'cancelButton', attribute: 'label' }
});
